import { render } from "./ProductList.vue?vue&type=template&id=06bc5f4e&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=06bc5f4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06bc5f4e"

export default script